"use strict";
exports.__esModule = true;
exports.UnionOf = void 0;
var functions_1 = require("./functions");
/**
 * A small class to help with constructing larger union checkers.
 *
 * @public
 */
var UnionOf = /** @class */ (function () {
    function UnionOf(ptt) {
        this.ptt = ptt;
    }
    /**
     * Finalise and return the partial type guard for this builder.
     */
    UnionOf.prototype.get = function () {
        return this.ptt;
    };
    /**
     * Add a new option for this union.
     */
    UnionOf.prototype["with"] = function (ptv) {
        return new UnionOf((0, functions_1.isUnion)(this.ptt, ptv));
    };
    return UnionOf;
}());
exports.UnionOf = UnionOf;
//# sourceMappingURL=unionof.js.map